import React from 'react';
import {
  Section,
  SectionHeader,
  WayPointHandler,
  AbsoluteCTA,
} from 'components';
import OurOffer from './OurOffer';
import './WhatWeDo.scss';

const About = () => (
  <WayPointHandler path="services">
    <Section>
      <SectionHeader
        color={'white'}
        lineColor={'red'}
        description={
          'We help clients to design and develop future-proof, significant and secure digital products that are centered around users’ needs and fulfil clients’ business goals.'
        }
        descriptionColor={'white'}
        additionalClass={'what-we-do__title'}
      >
        Services
      </SectionHeader>
      <OurOffer />
    </Section>
    <AbsoluteCTA linkID={'contact-services'} id={'page-home-services'} />
  </WayPointHandler>
);

export default About;
